<template>
  <div class="main-container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="迁徙路径分析-职住职娱(1004)" name="1004">
        <map-1004 v-if="is1004"></map-1004>
      </el-tab-pane>
      <el-tab-pane label="迁徙路径分析-住娱住职(1021)" name="1021">
        <map-1021 v-if="is1021"></map-1021>
      </el-tab-pane>
      <el-tab-pane label="迁徙路径分析-访住访职(1022)" name="1022">
        <map-1022 v-if="is1022"></map-1022>
      </el-tab-pane>
      <el-tab-pane label="迁徙路径分析-娱住(1023)" name="1023">
        <map-1023 v-if="is1023"></map-1023>
      </el-tab-pane>
      <!-- <el-tab-pane label="返回列表" name="1" style="background-color: #87ceeb;"></el-tab-pane> -->
    </el-tabs>
    <el-button type="primary" style='position: absolute;right:30px;top:30px;' @click="back">返回列表</el-button>
  </div>
</template>

<script>
import map1004 from './map1004.vue';
import map1021 from './map1021.vue';
import map1022 from './map1022.vue';
import map1023 from './map1023.vue';
export default {
  components: { map1004,map1021,map1022,map1023 },
  data(){
    return{
      activeName: '1004',
      is1004: true,
      is1021: false,
      is1022: false,
      is1023: false,
    }
  },
  methods: {
    handleClick(tab, event) {
      if (tab.name === '1004') {
        this.is1004 = true
        // this.is1021 = false
        // this.is1022 = false
        // this.is1023 = false
      } else if (tab.name === '1021') {
        // this.is1004 = false
        this.is1021 = true
        // this.is1022 = false
        // this.is1023 = false
      } else if (tab.name === '1022') {
        // this.is1004 =false
        // this.is1021 = false
        this.is1022 = true
        // this.is1023 = false
      } else if (tab.name === '1023') {
        // this.is1004 = false
        // this.is1021 = false
        // this.is1022 = false
        this.is1023 = true
      }
    },
    back(){
      this.$router.push({ path: '/unicomData/fenceUpload' })
    }
  },
}
</script>

<style>
.main-container {
  width: 80%;
  padding: 30px;
  margin: 0 auto;
  height: 100%;
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/views/unicomData/unicomMap.vue